import Logo from "@/components/Logo";
import { useTenantBrand } from "@/components/TenantBrandProvider";
import { sanitizeBrandUrl } from "@/lib/tenant-brand";

export default function TenantLogo({ size = 22, showWordmark = true, className = "" }) {
  const { brand } = useTenantBrand();
  const name = brand.productName || "Workspace";
  const accent = brand.colors?.primary || "var(--primary)";

  if (brand.enabled && brand.logoUrl) {
    const logoSrc = sanitizeBrandUrl(brand.logoUrl);
    if (!logoSrc) {
      return <Logo size={size} showWordmark={showWordmark} accent={accent} className={className} />;
    }
    return (
      <div className={`flex items-center gap-2.5 min-w-0 ${className}`} data-testid="tenant-logo">
        <img
          src={logoSrc}
          alt={name}
          className="object-contain shrink-0"
          style={{ height: size, maxWidth: size * 4 }}
        />
        {showWordmark ? (
          <span className="font-heading text-[var(--text-primary)] font-semibold tracking-tight text-base truncate">
            {name}
          </span>
        ) : null}
      </div>
    );
  }

  if (brand.enabled && brand.mode === "full") {
    return (
      <div className={`flex items-center gap-2.5 min-w-0 ${className}`} data-testid="tenant-logo-text">
        <span
          className="inline-flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-sm font-heading text-xs font-bold"
          style={{ background: `${accent}22`, color: accent, border: `1px solid ${accent}55` }}
        >
          {name.slice(0, 1).toUpperCase()}
        </span>
        {showWordmark ? (
          <span className="font-heading text-[var(--text-primary)] font-semibold tracking-tight text-base truncate">
            {name}
          </span>
        ) : null}
      </div>
    );
  }

  return <Logo size={size} showWordmark={showWordmark} accent={accent} />;
}
